///
/// EarthBrowser
///
/// Migration v2 to v3: Add aurora color palette fields
///
/// This migration adds the auroraColorPalette and customAuroraPalettes fields
/// for users with existing persisted state.
///

interface StateV2 {
	earthbrowser?: {
		auroraColorPalette?: string
		customAuroraPalettes?: unknown[]
	}
}

/**
 * Migration from version 2 to 3: Add aurora palette fields
 * - auroraColorPalette: string (defaults to "classic")
 * - customAuroraPalettes: array (defaults to empty)
 *
 * Note: Redux freezes state objects, so we must return a new object rather than mutate
 */
export function migrateV2toV3(state: unknown): unknown {
	if (!state) {
		return state
	}

	const s = state as StateV2
	const oldEarthbrowser = s.earthbrowser || {}

	// Create new earthbrowser state with aurora palette fields
	const newEarthbrowser = {
		...oldEarthbrowser,
		auroraColorPalette: oldEarthbrowser.auroraColorPalette ?? "classic",
		customAuroraPalettes: oldEarthbrowser.customAuroraPalettes ?? []
	}

	// Return completely new state object
	return {
		...s,
		earthbrowser: newEarthbrowser
	}
}
